import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import {
    IInvoicePayment,
    ISubscriptionInvoice,
    IInvoiceCreate,
    IManualPayment,
    IPage,
} from '../interfaces/billing.interface';

export const SubscriptionBillingService = {
    getMyInvoices: async (page = 0, size = 20): Promise<IPage<ISubscriptionInvoice>> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(
            `${ENDPOINTS.SUBSCRIPTION_INVOICE.BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`,
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    payWithBkash: async (invoiceId: string): Promise<{ redirectUrl: string }> => {
        const response = await axios.post(
            ENDPOINTS.SUBSCRIPTION_INVOICE.PAY_BKASH(invoiceId),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    getAllInvoices: async (page = 0, size = 20): Promise<IPage<ISubscriptionInvoice>> => {
        const response = await axios.get(
            `${ENDPOINTS.SUBSCRIPTION_INVOICE.BASE}?page=${page}&size=${size}`,
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    createInvoice: async (payload: IInvoiceCreate): Promise<ISubscriptionInvoice> => {
        const response = await axios.post(
            ENDPOINTS.SUBSCRIPTION_INVOICE.BASE,
            payload,
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    issueInvoice: async (id: string): Promise<ISubscriptionInvoice> => {
        const response = await axios.patch(
            ENDPOINTS.SUBSCRIPTION_INVOICE.ISSUE(id),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    cancelInvoice: async (id: string): Promise<ISubscriptionInvoice> => {
        const response = await axios.patch(
            ENDPOINTS.SUBSCRIPTION_INVOICE.CANCEL(id),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    markPaid: async (id: string, payload: IManualPayment): Promise<IInvoicePayment> => {
        const response = await axios.post(
            ENDPOINTS.SUBSCRIPTION_INVOICE.MARK_PAID(id),
            payload,
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    resolvePayment: async (paymentId: string): Promise<IInvoicePayment> => {
        const response = await axios.post(
            ENDPOINTS.SUBSCRIPTION_INVOICE.RESOLVE_PAYMENT(paymentId),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    markRefunded: async (paymentId: string): Promise<IInvoicePayment> => {
        const response = await axios.patch(
            ENDPOINTS.SUBSCRIPTION_INVOICE.MARK_REFUNDED(paymentId),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },
};
